import { DeviceType } from 'services/pangolin/types';
import { SearchInputStore } from '../search_input/search_input_store';
import { observable } from 'mobx';

export class DeviceTypeInputStore {
  @observable.ref
  deviceType: DeviceType | undefined;

  search: SearchInputStore;

  constructor(name: DeviceType | undefined) {
    this.deviceType = name;
    this.search = new SearchInputStore();
  }

  commitType = (value: DeviceType): void => {
    this.deviceType = value;
  };

  removeType = (): void => {
    this.deviceType = undefined;
  };
}
